import { useState } from 'react';
import { PlayerPortalsForm } from 'libs/common-forms-ui/src/lib/PlayerPortals/PlayerPortalsForm/PlayerPortalsForm';
import { PlayersSearchSelect } from './PlayersSearchSelect';
import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

type CreateCaddieFormProps = {
  allPlayers: any[];
  createCaddieForm: any;
  onFormClosed?: () => void;
};

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
const NO_PLAYER_SELECTED_MESSAGE = 'Please select a championship player.';
const ChampionshipPlayerFieldLabel = 'Assign To Championship Player';

export const CreateCaddieForm = (props: CreateCaddieFormProps) => {
  const { allPlayers, createCaddieForm, onFormClosed } = props;

  const [selectedPlayerId, setSelectedPlayerId] = useState<string>('');
  const [isPlayerFieldTouched, setIsPlayerFieldTouched] = useState(false);

  const hasPlayerError = isPlayerFieldTouched && !selectedPlayerId;

  const handlePlayerChange = (playerId: string) => {
    setIsPlayerFieldTouched(true);
    setSelectedPlayerId(playerId);
  };

  return (
    <div className={styles.createCaddieFormContainer}>
      <h2 className={styles.createCaddieTitle}>Create New Caddie</h2>

      <div className={styles.championshipPlayerField}>
        <label className={styles.championshipPlayerLabel}>
          {ChampionshipPlayerFieldLabel}
        </label>
        <PlayersSearchSelect
          players={allPlayers || []}
          selectedPlayerId={selectedPlayerId}
          onPlayerChange={handlePlayerChange}
          onBlur={() => setIsPlayerFieldTouched(true)}
          error={hasPlayerError}
          errorMessage={NO_PLAYER_SELECTED_MESSAGE}
        />
      </div>

      <div
        className={`${styles.createCaddieFormWrapper} ${
          selectedPlayerId ? styles.enabled : ''
        }`}
      >
        <PlayerPortalsForm
          {...createCaddieForm}
          isCreateCaddieForm
          selectedChampionshipCaddieId={EMPTY_GUID}
          selectedChampionshipPlayerId={selectedPlayerId}
          onFormClosed={onFormClosed}
        />
      </div>
    </div>
  );
};
